import { render, staticRenderFns } from "./activityCreateInstituteOrUser.html?vue&type=template&id=6df27518&scoped=true&external"
import script from "./activityCreateInstituteOrUser.vue?vue&type=script&lang=js"
export * from "./activityCreateInstituteOrUser.vue?vue&type=script&lang=js"
import style0 from "./activityCreateInstituteOrUser.css?vue&type=style&index=0&id=6df27518&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df27518",
  null
  
)

export default component.exports